// Class-name merge helper. Wraps clsx so component code stays
// dependency-light and we have ONE place to swap implementations
// (e.g., layer twMerge in Phase 4b.X if Tailwind class collisions
// start mattering). Component authors import from here, never from
// clsx directly.

import clsx, { type ClassValue } from "clsx";

export function cx(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
